<template>
  <div>
    <v-card flat>
      <v-app-bar color="primary" short dense flat dark v-if="session">
        <v-toolbar-title>Data Pribadi</v-toolbar-title>
        <v-spacer></v-spacer>

        <div
          class="mr-3 mt-1"
          v-if="
            session.authorities.some((item) => item === 'CRUD_ADMINISTRATOR')
          "
        >
          <CModalEdit />
        </div>

        <div style="max-width: 300px">
          <v-tabs v-model="tab" right dark background-color="primary">
            <v-tab href="#tab-1" @click="getSIMASN()">
              <h5>IDASN</h5>
            </v-tab>

            <v-tab href="#tab-2" @click="getSAPK()">
              <h5>SIASN</h5>
            </v-tab>
          </v-tabs>
        </div>
      </v-app-bar>

      <v-tabs-items v-model="tab" touchless>
        <v-tab-item value="tab-1" class="pa-5">
          <datautama />
        </v-tab-item>
        <v-tab-item value="tab-2" class="pa-5">
          <Vsiasn />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import Cookie from "@/helper/cookie.js";
import datautama from "@/components/asn/profil/datautama/datautama";
import Vsiasn from "@/components/asn/profil/datautama/siasn";
import CModalEdit from "@/components/asn/profil/datautama/ModalEdit";

import getData from "@/store/asn/datautama/tabs";

export default {
  name: "DataUtama",

  components: {
    datautama,
    Vsiasn,
    CModalEdit,
  },

  computed: {
    dataSAPK: {
      get() {
        return getData.state.tabSAPK;
      },

      set(value) {
        getData.commit("getSAPK", value);
      },
    },
  },

  data: () => ({
    tab: null,
    session: "",
  }),

  mounted() {
    this.session = JSON.parse(Cookie.dec(Cookie.get("myCookie")));
  },

  methods: {
    getSIMASN() {
      getData.commit("getSIMASN", true);
      getData.commit("getSAPK", false);
    },

    getSAPK() {
      getData.commit("getSIMASN", false);
      getData.commit("getSAPK", true);
    },
  },
};
</script>
